import React from 'react';

interface TeamCardsDueSectionProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /* tslint:disable:no-any */
  dueDateCards: any[]; // TODO: TMON-817 Only pass ids down instead of models
  /* tslint:enable:no-any */
}

export const TeamCardsDueSection: React.StatelessComponent<
  TeamCardsDueSectionProps
> = ({ children, dueDateCards, ...props }) => (
  <div {...props}>
    <div>{'<TeamCardsDueSection>'}</div>
    {/* TMON-880 Due date card feed */}
    <div>Due date feed here</div>
    {/* TMON-882 right-side tab bar */}
    <div>Scroll sidebar here</div>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./app/scripts/views/home/presentational/team-cards-due-section.tsx